import PhoneIcon from '@mui/icons-material/Phone'
import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded'
import { Box, Container, InputAdornment, Typography } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import * as Yup from 'yup'

import * as routes from '../../config/constants'
import Button from '../../shared/Button'
import { Form, FormField, SubmitButton } from '../../shared/forms'
import {
  confirmPhoneNumber,
  getError,
  getIsPasswordChanged,
  getMessage,
  getPhoneNumber,
  setError,
  setMessage,
} from '../../store/auth'
// Define interface and  validationSchema form
interface FormValues {
  phoneNumber: string
  confirmationCode: string
}

const validationSchema = Yup.object().shape({
  phoneNumber: Yup.string().required().label('phone number'),
  confirmationCode: Yup.string()
    .max(6)
    .required('وارد کردن کد ارسالی اجباری است')
    .label('confirmationCode'),
})

const ConfirmRegisterScreen: React.FC = () => {
  const message = useSelector(getMessage)
  const phoneNumber = useSelector(getPhoneNumber)

  const { enqueueSnackbar } = useSnackbar()
  const location = useLocation()
  const initialValues: FormValues = {
    phoneNumber,
    confirmationCode: '',
  }
  const isPasswordChanged = useSelector(getIsPasswordChanged)
  const navigate = useNavigate()

  useEffect(() => {
    if (phoneNumber === undefined) navigate(`/${routes.LOGIN}`)
  }, [phoneNumber])
  const { t } = useTranslation()
  const dispatch = useDispatch<Dispatch<any>>()
  const error = useSelector(getError)
  const handleSubmit = (values: any) => {
    dispatch(confirmPhoneNumber(values))
  }
  useEffect(() => {
    if (message === undefined) return
    enqueueSnackbar(message, { variant: 'success' })
    dispatch(setMessage(undefined))
    navigate(`/${routes.LOGIN}`)
  }, [message])
  useEffect(() => {
    if (error === undefined) return
    enqueueSnackbar(error, { variant: 'error' })

    dispatch(setError(undefined))
  }, [error])
  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener('popstate', function (event) {
      window.history.pushState(null, document.title, window.location.href)
    })
  }, [])
  return (
    <Container fixed maxWidth='xs'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Box display='flex' justifyContent='center'>
          <img alt='Logo' src='images/Logo.png' />
        </Box>
        <Box sx={{ mb: 2, ml: 1 }}>
          <Typography sx={{ color: 'grey.700', fontSize: 19 }} variant='h5'>
            {t('screens.auth.confirmRegister.title_code')}
          </Typography>
          <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}></Box>
        </Box>
        <Box sx={{ direction: 'ltr' }}>
          <Form
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            <FormField
              disabled
              name='phoneNumber'
              placeholder={t('screens.auth.confirmRegister.phone_number_placeholder')}
              startAdornment={
                <InputAdornment position='start'>
                  <PhoneIcon />
                </InputAdornment>
              }
              sx={{ backgroundColor: 'white' }}
            />
            <FormField
              name='confirmationCode'
              placeholder={t('screens.auth.confirmRegister.confirm_code_placeholder')}
              startAdornment={
                <InputAdornment position='start'>
                  <VpnKeyRoundedIcon />
                </InputAdornment>
              }
            />

            <SubmitButton title={t('screens.auth.confirmRegister.submit_button_text')} />
          </Form>
        </Box>
        <Box sx={{ mt: 2, display: 'flex', direction: 'rtl' }}>
          <Button onClick={() => navigate(`/${routes.LOGIN}`, { replace: true })} variant='text'>
            {t('screens.auth.register.login_button_text')}
          </Button>
        </Box>
      </Box>
    </Container>
  )
}

export default ConfirmRegisterScreen
